import { render, staticRenderFns } from "./AddGeneralModal.vue?vue&type=template&id=734aea03"
import script from "./AddGeneralModal.vue?vue&type=script&lang=js"
export * from "./AddGeneralModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports